import { render } from "./SlideOver.vue?vue&type=template&id=063c503b"
import script from "./SlideOver.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideOver.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/SlideOver.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "063c503b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('063c503b', __exports__)) {
    api.reload('063c503b', __exports__)
  }
  
  module.hot.accept("./SlideOver.vue?vue&type=template&id=063c503b", () => {
    api.rerender('063c503b', render)
  })

}


export default __exports__